export default __webpack_public_path__ + "static/media/YAS0410.34I-29770_-17204_0.01c06687.jpg";